/** Droppable month/week/day cell. */
import { useDroppable } from "@dnd-kit/core";

interface CellProps {
  id: string;
  testId: string;
  label?: string;
  isToday?: boolean;
  isOtherMonth?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}

export function CalendarCell({ id, testId, label, isToday, isOtherMonth, onClick, children }: CellProps): JSX.Element {
  const { isOver, setNodeRef } = useDroppable({ id });
  return (
    <div
      ref={setNodeRef}
      data-testid={testId}
      onClick={onClick}
      className={`relative flex min-h-[110px] flex-col gap-1 border border-border/50 p-1.5 transition ${
        isOver ? "bg-primary/10 ring-2 ring-primary/40" : ""
      } ${isOtherMonth ? "bg-muted/30" : "bg-background"}`}
    >
      {label ? (
        <div className="flex items-center justify-between">
          <span
            className={`inline-flex h-6 w-6 items-center justify-center rounded-full text-[11px] font-medium ${
              isToday ? "bg-primary text-primary-foreground" : "text-muted-foreground"
            }`}
          >
            {label}
          </span>
        </div>
      ) : null}
      <div className="flex flex-1 flex-col gap-1 overflow-hidden">{children}</div>
    </div>
  );
}
